'use client';

import { useLocale, useTranslations } from 'next-intl';
import { Button } from '@/src/shared/ui/button';
import { Separator } from '@/src/shared/ui/separator';
import { BrandMark, LocaleSwitcher, ThemeToggle } from '@/src/shared/ui';
import type { NavLink } from '../model/navigation';

type Props = {
  navLinks: NavLink[];
  onClose: () => void;
};

export function MobileMenu({ navLinks, onClose }: Props) {
  const locale = useLocale();
  const t = useTranslations('nav');
  const tLinks = useTranslations('nav.links');
  const tBrand = useTranslations();

  return (
    <div className="flex h-full flex-col">
      {/* Header */}
      <div className="flex items-center gap-2.5 border-b px-5 py-4">
        <BrandMark size="sm" />
        <span className="text-sm font-semibold tracking-tight">{tBrand('appName')}</span>
      </div>

      {/* Nav links */}
      <nav className="flex flex-1 flex-col gap-1 px-3 py-5">
        {navLinks.map((link) => (
          <a
            key={link.id}
            href={link.href}
            onClick={onClose}
            className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground/80 transition-colors hover:bg-accent hover:text-accent-foreground"
          >
            {tLinks(link.id)}
          </a>
        ))}
      </nav>

      {/* Footer controls */}
      <div className="px-3 pb-5">
        <Separator className="mb-4" />
        {/* Plain anchors, not next/link: proxy.ts sends these routes to the app host, and a client-side fetch there fails on CORS. */}
        <Button className="mb-2 w-full" size="sm" variant="outline" asChild>
          <a href={`/${locale}/login`} onClick={onClose}>
            {t('login')}
          </a>
        </Button>
        <Button className="mb-3 w-full" size="sm" asChild>
          <a href={`/${locale}/register`} onClick={onClose}>
            {t('cta')}
          </a>
        </Button>
        <div className="flex items-center gap-1">
          <LocaleSwitcher />
          <ThemeToggle />
        </div>
      </div>
    </div>
  );
}
